module.exports = __webpack_public_path__ + "static/js/1.da2b4697.worker.js"